import React from 'react'
import { graphql, useStaticQuery } from 'gatsby'
import trimHtml from 'trim-html'
import { Link, Imgix } from '@elements'

export const WhatsNews = () => {
  const data = useStaticQuery(graphql`
    query {
      wpgraphql {
        recentPosts: posts(first: 3, where: { status: PUBLISH }) {
          edges {
            node {
              featuredImage {
                node {
                  altText
                  mediaItemUrl
                }
              }
              uri
              title
              excerpt(format: RENDERED)
              id
            }
          }
        }
      }
    }
  `)

  const posts = data.wpgraphql.recentPosts.edges

  return (
    <div className="my-20">
      <h2 className="font-sans text-4xl font-bold leading-tight tracking-wider text-center uppercase text-brand-red sm:text-5xl">
        What's News?
      </h2>
      <div className="grid gap-16 pt-10 mt-6 border-t-2 border-gray-400 lg:grid-cols-3 lg:col-gap-5 lg:row-gap-12">
        {posts.map(({ node }) => {
          const formattedExcerpt = trimHtml(node.excerpt, {
            limit: 125,
            preserveTags: true,
            suffix: '...',
          }).html.replace(/(<([^>]+)>)/gi, '')
          return (
            <div key={node.id}>
              <Link to={node.uri} className="block">
                {node.featuredImage && (
                  <div className="relative w-full h-64 overflow-hidden lg:h-40">
                    <Imgix
                      src={node.featuredImage.node.mediaItemUrl}
                      alt={node.featuredImage.node.altText}
                      className="absolute inset-0 object-cover w-full h-full"
                    />
                  </div>
                )}
                <h3 className="mt-4 font-sans text-2xl font-bold leading-7 text-gray-400 uppercase">
                  {node.title}
                </h3>
                <p className="mt-3 text-base leading-6 text-gray-500">
                  {formattedExcerpt}
                </p>
              </Link>
              <div className="mt-3">
                <Link
                  to={node.uri}
                  className="font-sans text-base font-bold leading-6 text-gray-400 no-underline uppercase transition duration-150 ease-in-out border-b-4 hover:border-brand-yellow"
                >
                  Read full story
                </Link>
              </div>
            </div>
          )
        })}
      </div>
      <div className="flex items-center justify-center pt-0 pb-5">
        <Link
          to="/news/"
          className="inline-block px-10 pt-1 mt-12 font-sans text-2xl font-bold text-gray-400 no-underline uppercase transition duration-200 border-6 border-brand-yellow hover:bg-brand-yellow"
        >
          Read More
        </Link>
      </div>
    </div>
  )
}
